import { hasClass } from '@opten/dom/has-class';
import { Component } from '@opten/compiler/metadata/component';
import { getOffset } from '@opten/dom/get-offset';
import { getCss } from '@opten/dom/get-css';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { getStickyOffset } from '../utilities/scroll-helper';
import { isDesktop } from '../utilities/detection';

@Component({ className: 'js-scroll-to-bottom-part-page',observe: true })
export class ScrollToBottomPartPageComponent{
	
	
	bottomPartPage: Element;


	constructor(private element: HTMLElement) {
		
		this.bottomPartPage = document.querySelector('.js-bottom-part-page');
		if(this.bottomPartPage){
			this.element.addEventListener('click', (e) => this.handleScollToBottomPartPage(e))
		}
	}
	handleScollToBottomPartPage(e: Event) {
		e.preventDefault();
		e.stopPropagation();

        if (this.bottomPartPage) {
            let offset = getOffset(this.bottomPartPage).top();

            offset += parseCssUnit(getCss(this.bottomPartPage, 'margin-top')) * -1;
            offset += getStickyOffset() * -1;

			offset = Math.round(offset);
			if(hasClass(this.bottomPartPage,'js-tab-content') || hasClass(this.bottomPartPage,'section--large__bottom')){
				offset -= isDesktop() ? 100 : 65;
			}

            window.scrollTo(0, offset);
        }
	}

}